import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../../contexts/CartContext';
import CartDrawer from './CartDrawer';

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isCheckoutOpen, setIsCheckoutOpen] = useState(false);
  const location = useLocation();
  const { itemCount } = useCart();
  const cartCount = itemCount;

  return (
    <>
      <nav className="fixed top-0 left-0 right-0 z-30 bg-white/95 backdrop-blur-sm shadow-sm">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-3 cursor-pointer">
              <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-violet-600 to-purple-600 rounded-lg">
                <i className="ri-code-s-slash-line text-2xl text-white"></i>
              </div>
              <span className="text-2xl font-bold bg-gradient-to-r from-violet-600 to-purple-600 bg-clip-text text-transparent">
                AZZ MATRIX
              </span>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center gap-8">
              <Link
                to="/"
                className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  location.pathname === '/'
                    ? 'text-violet-600'
                    : 'text-gray-700 hover:text-violet-600'
                }`}
              >
                Home
              </Link>
              <Link
                to="/services"
                className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  location.pathname === '/services'
                    ? 'text-violet-600'
                    : 'text-gray-700 hover:text-violet-600'
                }`}
              >
                Services
              </Link>
              <Link
                to="/contact"
                className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  location.pathname === '/contact'
                    ? 'text-violet-600'
                    : 'text-gray-700 hover:text-violet-600'
                }`}
              >
                Contact
              </Link>

              {/* Cart Icon with Badge */}
              <button
                onClick={() => setIsCartOpen(true)}
                className="relative w-10 h-10 flex items-center justify-center rounded-full hover:bg-violet-50 transition-colors cursor-pointer"
                aria-label="Shopping cart"
              >
                <i className="ri-shopping-cart-2-line text-2xl text-gray-700"></i>
                {cartCount > 0 && (
                  <span className="absolute -top-1 -right-1 w-5 h-5 flex items-center justify-center bg-gradient-to-r from-violet-600 to-purple-600 text-white text-xs font-bold rounded-full">
                    {cartCount}
                  </span>
                )}
              </button>

              <Link
                to="/contact"
                className="px-6 py-2.5 bg-gradient-to-r from-violet-600 to-purple-600 text-white rounded-lg font-semibold hover:from-violet-700 hover:to-purple-700 transition-all cursor-pointer whitespace-nowrap"
              >
                Get Started
              </Link>
            </div>

            {/* Mobile Menu Button & Cart */}
            <div className="md:hidden flex items-center gap-3">
              {/* Mobile Cart Icon */}
              <button
                onClick={() => setIsCartOpen(true)}
                className="relative w-10 h-10 flex items-center justify-center rounded-full hover:bg-violet-50 transition-colors cursor-pointer"
                aria-label="Shopping cart"
              >
                <i className="ri-shopping-cart-2-line text-2xl text-gray-700"></i>
                {cartCount > 0 && (
                  <span className="absolute -top-1 -right-1 w-5 h-5 flex items-center justify-center bg-gradient-to-r from-violet-600 to-purple-600 text-white text-xs font-bold rounded-full">
                    {cartCount}
                  </span>
                )}
              </button>

              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="w-10 h-10 flex items-center justify-center text-gray-700 cursor-pointer"
              >
                <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
              </button>
            </div>
          </div>

          {/* Mobile Menu */}
          {isMenuOpen && (
            <div className="md:hidden mt-4 py-4 border-t border-gray-200">
              <div className="flex flex-col gap-4">
                <Link
                  to="/"
                  onClick={() => setIsMenuOpen(false)}
                  className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    location.pathname === '/'
                      ? 'text-violet-600'
                      : 'text-gray-700 hover:text-violet-600'
                  }`}
                >
                  Home
                </Link>
                <Link
                  to="/services"
                  onClick={() => setIsMenuOpen(false)}
                  className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    location.pathname === '/services'
                      ? 'text-violet-600'
                      : 'text-gray-700 hover:text-violet-600'
                  }`}
                >
                  Services
                </Link>
                <Link
                  to="/contact"
                  onClick={() => setIsMenuOpen(false)}
                  className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    location.pathname === '/contact'
                      ? 'text-violet-600'
                      : 'text-gray-700 hover:text-violet-600'
                  }`}
                >
                  Contact
                </Link>
                <Link
                  to="/contact"
                  onClick={() => setIsMenuOpen(false)}
                  className="px-6 py-2.5 bg-gradient-to-r from-violet-600 to-purple-600 text-white rounded-lg font-semibold hover:from-violet-700 hover:to-purple-700 transition-all text-center cursor-pointer whitespace-nowrap"
                >
                  Get Started
                </Link>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Cart Drawer */}
      <CartDrawer
        isOpen={isCartOpen}
        onClose={() => setIsCartOpen(false)}
        onCheckout={() => setIsCheckoutOpen(true)}
      />
    </>
  );
}